import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Luggage02 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="luggage-02">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.625 5C9.50677 5 9.4375 5.09033 9.4375 5.16923V6.50769H13.9688V5.16923C13.9688 5.09033 13.8995 5 13.7812 5H9.625ZM15.9688 6.50769V5.16923C15.9688 3.95664 14.9747 3 13.7812 3H9.625C8.43155 3 7.4375 3.95664 7.4375 5.16923V6.50769H4.875C3.02571 6.50769 1.5 7.98781 1.5 9.84615V16.8615C1.5 18.7199 3.02571 20.2 4.875 20.2H19.125C20.9743 20.2 22.5 18.7199 22.5 16.8615V9.84615C22.5 7.98781 20.9743 6.50769 19.125 6.50769H15.9688ZM14.5625 8.50769H8.84375V18.2H14.5625V8.50769ZM16.5625 18.2H19.125C19.8991 18.2 20.5 17.5862 20.5 16.8615V9.84615C20.5 9.1215 19.8991 8.50769 19.125 8.50769H16.5625V18.2ZM6.84375 18.2V8.50769H4.875C4.10093 8.50769 3.5 9.1215 3.5 9.84615V16.8615C3.5 17.5862 4.10093 18.2 4.875 18.2H6.84375Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
